export default function HamburgerIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="38"
			height="38"
			viewBox="0 0 38 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.5"
				y="0.5"
				width="37"
				height="37"
				rx="18.5"
				stroke="white"
				stroke-opacity="0.2"
			/>
			<path
				d="M27 13H11"
				stroke="#FBFBFB"
				stroke-width="2"
				stroke-linecap="round"
			/>
			<path
				d="M27 19H15"
				stroke="#FBFBFB"
				stroke-width="2"
				stroke-linecap="round"
			/>
			<path
				d="M27 25H21"
				stroke="#FBFBFB"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</svg>
	);
}
